import React, { useState } from "react";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import { Divider, makeStyles, Typography } from "@material-ui/core";
import Text from "../../components/Text";
import moment from "moment";
import PageItem from "../../components/PageItem";
import { TextInput, DateInput } from "../../components/Form";
import Grid from "../../components/Grid";
import Button from "../../components/Button";

export default function BranchManageTable({
  dateStart,
  onChangeDateStart = () => {},
  dateEnd,
  onChangeDateEnd = () => {},
}) {
  const data = [];
  const [newData, setNewData] = useState({
    signal: "",
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  const useStyles = makeStyles({
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
    },
    DocumentContainerButtonEnd: {
      display: "flex",
      alignItems: "flex-end",
    },
  });
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              日期
            </Typography>
            <DateInput
              format="yyyy年MM月dd日"
              value={dateStart}
              onChange={(v) =>
                onChangeDateStart(moment(v).format("YYYY-MM-DD"))
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              至
            </Typography>
            <DateInput
              format="yyyy年MM月dd日"
              value={dateEnd}
              minDate={dateStart}
              onChange={(v) => onChangeDateEnd(moment(v).format("YYYY-MM-DD"))}
              fullWidth
            />
          </Grid>
          <Grid item xs={8} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              分店
            </Typography>
            <TextInput value={newData.signal} fullWidth />
          </Grid>
          <Grid
            item
            xs={4}
            classes={{ root: classes.DocumentContainerButtonEnd }}
          >
            <Button size="small" color="primary" variant="contained">
              搜尋
            </Button>
          </Grid>
          <Grid
            item
            xs={8}
            sm={3}
            classes={{ root: classes.DocumentContainerEnd }}
          >
            <TextInput label="輸入名稱" value={newData.signal} fullWidth />
          </Grid>
          <Grid
            item
            xs={4}
            classes={{ root: classes.DocumentContainerButtonEnd }}
          >
            <Button  size="small" color="primary" variant="contained">
              新增分店
            </Button>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Table
          data={data}
          tableWidth={2}
          header={[
            "編號",
            "店名",
            "負責人",
            "部門",
            "連絡電話",
            "服務業務",
            "加入時間",
            "到期時間",
            "顯示狀態(外部)",
            "刪除",
          ]}
          columns={[
            (item) => <Text>{item.code}</Text>,
            (item) => <Text>{item.numberDebtor}</Text>,
            (item) => <Text>{item.address}</Text>,
            (item) => <Text>{item.date}</Text>,
            (item) => <Text>{item.status}</Text>,
            (item) => <Text>{item.floor}</Text>,
            (item) => <Text>{item.floorMillion}</Text>,
            (item) => <Text>{item.margin}</Text>,
            (item) => (
              <Button variant="contained" onPress>
                顯示
              </Button>
            ),
            (item) =>(
              <Button variant="contained" onPress>
                刪除
              </Button>
            ),
          ]}
        />
      </CardContent>
      <CardActions>
        <PageItem
          data={newData.pageArray}
          page={newData.page}
          onChangePage={(e) => changeData("page", e, true)}
        />
      </CardActions>
    </Card>
  );
}
